import { ReactElement, ReactNode } from 'react'
import { Input } from 'antd'

import './search-input.scss'

interface CustomInputProps {
  placeholder?: string,
  onChange?: (event: React.ChangeEvent<HTMLInputElement>) => void,
  value?: string,
  style?: {[key: string]: string},
  className?: string,
  prefix?: ReactNode,
  type?: string,
  disabled?: boolean
}

const SearchInput: React.FC<CustomInputProps> = (
  {
    placeholder,
    style,
    className,
    prefix
  }
): ReactElement => (
  <Input
    style={style}
    prefix={prefix}
    className={`search-input ${className}`}
    placeholder={placeholder}
  />
)

export default SearchInput